import * as administrator from "./administrator";
import * as common from "./common";
import * as company from "./company";

const get = {
  administrator,
  common,
  company,
};

export default get;
